import type { ContentRef } from '@gitbook/api-client';
import { renderIcon } from '@gitbook/spine-react';

import { useContentReference } from '../..';

export function ContentRefPreview(props: { contentRef: ContentRef }) {
    const resolved = useContentReference(props.contentRef);

    return (
        <div className="flex items-center gap-1.5 truncate">
            {resolved.icon ? renderIcon(resolved.icon, { size: 16, className: 'shrink-0' }) : null}
            <span className="flex-1 truncate">{resolved.title}</span>
        </div>
    );
}
